import { fetchJSON as fetchAPI } from './client';

export type AlphaDashboardSnapshot = {
  tenant_id: string; alpha_day: number; overall_validation_score: number;
  workflows_validated: number; workflows_total: number; kartmanage_first_rate_pct: number;
  defects_critical: number; defects_high: number; recommendation_adoption_pct: number;
  time_saved_hours_per_week: number; founder_daily_use: string;
  exit_criteria_met: number; exit_criteria_total: number;
};

export type ChecklistItem = { key: string; label: string; phase: string; complete: boolean };

export type DailyChecklistSnapshot = {
  morning: ChecklistItem[]; during_day: ChecklistItem[]; end_of_day: ChecklistItem[];
  morning_completion_pct: number; during_completion_pct: number; eod_completion_pct: number;
};

export type WorkflowStep = {
  step: string; status: string; gap?: string; friction_score: number; kartmanage_first: boolean;
};

export type WorkflowValidationSnapshot = {
  steps: WorkflowStep[]; validated_count: number; gap_count: number; avg_friction_score: number;
};

export type RecommendationEntry = {
  id: string; recommendation: string; evidence: string; confidence: number;
  decision: string; reason?: string; business_outcome?: string; actual_impact?: string; learning_outcome?: string;
};

export type DefectEntry = {
  id: string; severity: string; description: string; reproduction_steps: string;
  expected_behaviour: string; actual_behaviour: string; business_impact: string; status: string;
};

export type UXLogEntry = { id: string; trigger: string; screen: string; note: string; logged_at: string };

export type ExitCriterion = { key: string; label: string; met: boolean; detail?: string };

export type ExitCriteriaSnapshot = {
  criteria: ExitCriterion[]; met_count: number; total_count: number; ready_for_pilot: boolean;
};

export type SuccessMetricsSnapshot = {
  time_saved_hours_week: number; profit_improvement_pct: number; revenue_improvement_pct: number;
  recommendation_accuracy_pct: number; automation_rate_pct: number; workflow_completion_pct: number;
  customer_value_growth_pct: number;
};

const COMMAND_BASE = import.meta.env.VITE_COMMANDCENTER_API ?? '/api/v1/command';
const fetchC = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${COMMAND_BASE}${path}`, init);

export const internalAlphaApi = {
  dashboard: () => fetchC<AlphaDashboardSnapshot>('/internal-alpha/dashboard'),
  dailyChecklist: () => fetchC<DailyChecklistSnapshot>('/internal-alpha/daily-checklist'),
  workflow: () => fetchC<WorkflowValidationSnapshot>('/internal-alpha/workflow-validation'),
  recommendationLog: () => fetchC<{ entries: RecommendationEntry[] }>('/internal-alpha/recommendation-log').then((r) => r.entries),
  defects: () => fetchC<{ defects: DefectEntry[] }>('/internal-alpha/defects').then((r) => r.defects),
  uxLog: () => fetchC<{ entries: UXLogEntry[] }>('/internal-alpha/ux-log').then((r) => r.entries),
  exitCriteria: () => fetchC<ExitCriteriaSnapshot>('/internal-alpha/exit-criteria'),
  successMetrics: () => fetchC<SuccessMetricsSnapshot>('/internal-alpha/success-metrics'),
};
